import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { AxiosResponse } from "axios";

export abstract class IFileTypeApi {
	abstract getDomain(idSystemApplication: number): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
